module.exports = __webpack_public_path__ + "static/media/sunrise1_blur.6f94fb69.jpg";